// extracted by mini-css-extract-plugin
module.exports = {"alarm_page_header_wrapper":"Header_alarm_page_header_wrapper__rWQc1"};